import { Controller } from "@hotwired/stimulus";

/**
 * Read-only form controller
 *
 * Disables all form elements (inputs, selects, textareas, buttons) within its scope.
 * Use this controller to make wizard forms read-only when a calculation is submitted
 * and has not been reopened for editing.
 */
export default class extends Controller {
  connect() {
    // Wait for DOM to be fully rendered before disabling
    requestAnimationFrame(() => {
      this.disableAllFormElements();
    });

    // Observe for dynamically added elements (e.g., payroll entries)
    this.observer = new MutationObserver(() => {
      this.disableAllFormElements();
    });

    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  disableAllFormElements() {
    const elements = this.element.querySelectorAll(
      "input, select, textarea, button, [contenteditable]",
    );

    elements.forEach((element) => {
      // Skip hidden inputs (like CSRF tokens and method fields)
      if (element.type === "hidden") return;
      if (
        element.classList.contains("payroll-expander") ||
        element.id === "addon-expander"
      )
        return;

      // Skip elements that are already disabled
      if (element.disabled) return;

      // Skip elements inside excluded containers (like Reopen button)
      if (element.closest("[data-read-only-form-exclude]")) return;

      element.disabled = true;
      element.setAttribute("data-read-only-disabled", "true");
    });
  }
}
